import * as API from "middleware/api";

// eslint-disable-next-line import/prefer-default-export
export const listRequestsAndClaims = (filters) =>
    API.executeWithAccessToken("/requestandclaim.historicals.list", filters);
